import styled, { css } from 'styled-components'
import { themeColor } from 'LibNeo'

export const BgSelectWithOtherWrapper = styled.div<{ hasErr?: boolean }>`
	${({ hasErr }) =>
		hasErr &&
		css`
			.ant-select-search__field,
			.ant-select-search__field:hover {
				border-color: ${themeColor('pink', 5)};
			}
		`}
	.ant-select-dropdown-menu-item {
		white-space: initial;
		text-overflow: initial;
	}
`
